import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ApproveLeaveModal.module.css';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const ApproveLeaveModal = ({ open, onClose, onConfirm, request }) => {
  const [loading, setLoading] = useState(false);

  const handleApprove = async () => {
    if (!request?._id) {
      toast.error('Invalid request selected');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/gate_pass/gatepasses/${request._id}/status`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        },
        body: JSON.stringify({
          status: 'Approved',
          remark: `Approved by ${Cookies.get('Role')}`
        })
      });

      const result = await response.json();

      if (response.ok) {
        toast.success('Leave request approved successfully');
        onConfirm(); // tell parent to refresh table/list
        onClose(); // close modal
      } else {
        toast.error(result.message || 'Failed to approve request');
      }
    } catch (error) {
      console.error('Approve request failed:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={styles.approveModal}>
      {/* Header */}
      <DialogTitle className={styles.modalHeader}>
        <Typography variant="h6" className={styles.modalTitle}>
          Approve {request?.requestType} Request
        </Typography>
        <IconButton onClick={onClose} className={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent className={styles.modalContent}>
        <Typography variant="body1" className={styles.confirmationText}>
          Are you sure you want to approve this request?
        </Typography>
        <Typography variant="body2" className={styles.warningText}>
          Once confirmed, the status will be changed to <strong>Approved</strong> and cannot be reversed.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions className={styles.modalActions}>
        <Button onClick={onClose} variant="outlined" className={styles.cancelButton} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleApprove} variant="contained" className={styles.approveButton} disabled={loading}>
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Yes, Approve'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveLeaveModal;
